import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { CoreModule } from './core/core.module';
import { Ng2ImgToolsModule } from 'ng2-img-tools';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { HomeModule } from './home/home.module';
import { AppComponent } from './app.component';
import { ImpressumModule } from './impressum/impressum.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
	CoreModule,
	Ng2ImgToolsModule,
        SharedModule,
        HomeModule,
        HttpModule,
        AppRoutingModule,
        ImpressumModule
    ],
    bootstrap: [ AppComponent ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/app.module.ts